import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "app/axios";
import { RootState } from "app/store";
import { AxiosResponse } from "axios";
import { CertificateTypeInterface } from "interfaces/CertificateType";
import { UserRoles } from "interfaces/UserRoles";

export interface fetchCertificateTypesArgument {
  items_per_page?: number;
  page?: number;
  search?: string ;
  endpoint?: UserRoles;
}

interface CertificateTypesResponseInterface {
  data: {
      total: number;
      pages: number;
      certificate_types: CertificateTypeInterface[];
    };
}

export const getCertificateType = createAsyncThunk(
  "certificate_types/fetchCreateCertificateType",
  async (_, { getState }) => {
    const { user } = getState() as RootState;
    if (!user || !user.role) {
      throw new Error("User role is undefined.");
    }
    
    const response = await fetchCertificateTypes({ endpoint: user.role });
    return { headers: response.headers, data: response.data, status: response.status };
  }
);

export function fetchCertificateTypes({endpoint}: fetchCertificateTypesArgument): Promise<AxiosResponse<CertificateTypesResponseInterface, any>> {
  return axiosInstance.get(`${endpoint}/certificate_types`, {
    params: {
      items_per_page: 'unlimited',
    }
  });
}
